import Icon from '@/components/ui/AppIcon';

export default function TrustSignals() {
  const trustFeatures = [
    {
      icon: 'ShieldCheckIcon',
      title: 'Privacy First',
      description: 'Your number is never shared',
    },
    {
      icon: 'PhoneArrowUpRightIcon',
      title: 'Assisted Call System',
      description: 'Caller & owner connected via ParkPing',
    },
    {
      icon: 'BoltIcon',
      title: 'Instant Alerts',
      description: 'Real-time parking notifications',
    },
    {
      icon: 'ChatBubbleLeftRightIcon',
      title: 'Dedicated Support',
      description: 'Help when you actually need it',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {trustFeatures.map((feature, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center p-4 bg-card rounded-2xl border border-border hover:border-accent/30 shadow-subtle transition"
        >
          <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mb-3">
            <Icon
              name={feature.icon as any}
              size={24}
              className="text-accent"
            />
          </div>

          <h4 className="text-sm font-semibold text-foreground mb-1">
            {feature.title}
          </h4>
          <p className="text-xs text-muted-foreground">{feature.description}</p>
        </div>
      ))}
    </div>
  );
}
